class AccountUIModel {
  constructor({
    balance = undefined,
    tier = undefined,
    tierExpirationDate = undefined,
    frequentFlyerNumber = undefined,
    frequentFlyerProgram = undefined,
    login = undefined,
  } = {}) {
    this.balance = balance;
    this.tier = tier;
    this.tierExpirationDate = tierExpirationDate;
    this.frequentFlyerNumber = frequentFlyerNumber;
    this.frequentFlyerProgram = frequentFlyerProgram;
    this.login = login;
  }

  toApi() {
    return {
      '_meta':{
        'class':'ManageAccountProfile',
      },
      'balance': this.balance,
      'tier': this.tier,
      'tierExpirationDate': this.tierExpirationDate,
      'frequentFlyerNumber': this.frequentFlyerNumber,
      'frequentFlyerProgram': this.frequentFlyerProgram,
      'login': this.login,
    };
  }
}

export default AccountUIModel;
